import { render } from "./B2bTableMenuServiciosEmpresas.vue?vue&type=template&id=56e4ce9e&scoped=true&lang=pug"
import script from "./B2bTableMenuServiciosEmpresas.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuServiciosEmpresas.vue?vue&type=script&lang=js"

import "./B2bTableMenuServiciosEmpresas.vue?vue&type=style&index=0&id=56e4ce9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e4ce9e"]])

export default __exports__